import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, App } from 'ionic-angular';

import { ImcpaAppProvider } from '../../../providers/imcpaApp/imcpaApp';

import { LoginPage } from '../../login/login';
import { FarmListPage } from '../../farms/farmList/farmList';
import { CampaignListPage } from '../../campaigns/campaignList/campaignList';
import { ResourcesListPage } from '../../resources/resourceList/resourcesList';
import { CertificatePage } from '../../certificate/certificate/certificate';
import { TabsPage } from '../../tabs/tabs';

@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
  // styleUrls: [ 'dashboard.scss', '../../theme/variables.scss' ]
})
export class DashboardPage {

  public goshala: any;
  public countryStats: any = [];
  public cityStats: any = [];
  public yatraStats: any = [];
  public devoteeStats: any = [];

  constructor(public myApp: ImcpaAppProvider, public cf: ChangeDetectorRef, public navCtrl: NavController, public app: App) {
    // this.cf.detectChanges();
    console.log(this.myApp.isLoggedIn)
  }

  ionViewDidEnter(){
    this.cf.detectChanges();
  }

  goToLoginPage(){
    if(this.myApp.isLoggedIn){
      this.myApp.access = {};
      this.myApp.isLoggedIn = false;
      this.navCtrl.push(TabsPage)
      // this.app.getRootNavs()[0].setRoot(LoginPage)
    } else {
      this.navCtrl.push(LoginPage);
    }
    
  }

  goToFarmListPage(){
  if(this.myApp.isLoggedIn){
    this.navCtrl.setRoot(FarmListPage)
  } else {
    this.navCtrl.push(FarmListPage)
  }
  }

  goToTemplesListPage() {
    this.navCtrl.push(CampaignListPage)
  }
  
  goToResourcesListPage() {
    this.navCtrl.push(ResourcesListPage)
  }

  goToCertificatePage() {
    if(this.myApp.isLoggedIn){
      this.navCtrl.setRoot(CertificatePage)
    } else {
      this.navCtrl.push(CertificatePage)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard/dashboard.ts